import $ from "jquery";
import BD_Timer from "@bd-components/bd-timer";
import Store_SequenceHistory from "@bd-components/store-sequence-history";
import BD_Block from "@bd-core/bd-block";
import BD_GAME_LOGIC from "@bd-core/game-logic";
import { compile } from "@bd-utils/handlerbars-helper";
import { createQuestion } from "@bd-utils/question";

export class Block_Blank_Media extends BD_Block {
	constructor() {
		super();

		this.type = "blank_media";
		this.templateID = "blank-media-template";

		this.elms = {
			questionCard: ".questionCard",
			questionModal: ".question-modal",
			answer: ".js-answer",
			submit: ".js-submit",
			backWrapper: ".questionCard__back",
			back: ".js-back",
		};

		this._events = this.getEvents();
	}

	getEvents() {
		const elms = this.elms;
		return [
			{
				event: "click",
				selector: elms.submit,
				handler: this.submit,
			},
			{
				event: "click",
				selector: elms.back,
				handler: this.back,
			},
		];
	}

	beforeInit() {
		this.render();
		this.setGameState();
		this.setQuestion();
		this.setTimer();
	}

	render() {
		const htmlTemplate = $("#" + this.templateID).html();
		const html = compile(htmlTemplate, this._data);
		$("#templateWrapper").html(html);
		setTimeout(() => this.questionTransition(), 300);
	}

	questionTransition() {
		$(".question-modal").addClass("is-load-question")
	}

	setGameState() {
		const showBackBtn = () => {
			if (Store_SequenceHistory.data) {
				$(this.elms.backWrapper).addClass("is-active");
			}
		};

		showBackBtn();
	}

	setQuestion() {
		this.question = createQuestion(this._data.question);
		this._events = [...this._events, ...this.question.getEvents()];
		this.question.showSubmitBtn(this);
	}

	setTimer() {
		this.timer = new BD_Timer(this._data, this.question);
		this.timer.start();
	}

	back() {
		const seqHistory = Store_SequenceHistory.data;
		// @ts-ignore
		const currentBlockID = parseInt(BD_GAME_LOGIC.getCurrentBlockID());
		const history = seqHistory[currentBlockID];
		if (!history) return;

		BD_GAME_LOGIC.goBack(history.prev);
	}

	submit(e, $el) {
		this.question.submitAnswer($el, this);
	}

	afterDestroy() {
		this.timer.stop();
	}
}
